import { trpc } from "../../lib/trpc.js";
import { EditorDivulgacao } from "./EditorDivulgacao.js";
import { PaginaAcervo } from "./PaginaAcervo.js";

const IMAGENS = "image/jpeg,image/png,image/webp";

export function BancoImagensPage() {
  const lista = trpc.imageBank.list.useQuery();
  const utils = trpc.useUtils();
  const excluir = trpc.imageBank.deleteMany.useMutation({
    onSuccess: () => utils.imageBank.list.invalidate(),
  });

  return (
    <PaginaAcervo
      titulo="Banco de imagens"
      descricao="Referências que orientam o modelo — cenários, estilos, objetos. O operador escolhe até quatro por foto."
      rotaUpload="/api/image-bank/upload"
      itens={lista.data ?? []}
      carregando={lista.isLoading}
      proporcao="square"
      aceita={IMAGENS}
      aoRecarregar={() => void utils.imageBank.list.invalidate()}
      aoExcluir={async (ids) => void (await excluir.mutateAsync({ ids }))}
      excluindo={excluir.isPending}
    />
  );
}

export function CapasPage() {
  const lista = trpc.bookCovers.list.useQuery();
  const utils = trpc.useUtils();
  const excluir = trpc.bookCovers.deleteMany.useMutation({
    onSuccess: () => utils.bookCovers.list.invalidate(),
  });

  return (
    <PaginaAcervo
      titulo="Capas de livro"
      descricao="A capa ocupa os 40% de cima da peça final. Envie na proporção da capa impressa."
      rotaUpload="/api/book-covers/upload"
      itens={lista.data ?? []}
      carregando={lista.isLoading}
      proporcao="cover"
      aceita={IMAGENS}
      aoRecarregar={() => void utils.bookCovers.list.invalidate()}
      aoExcluir={async (ids) => void (await excluir.mutateAsync({ ids }))}
      excluindo={excluir.isPending}
    />
  );
}

export function DivulgacoesPage() {
  const lista = trpc.divulgacoes.list.useQuery();
  const utils = trpc.useUtils();
  const excluir = trpc.divulgacoes.delete.useMutation({
    onSuccess: () => utils.divulgacoes.list.invalidate(),
  });

  return (
    <PaginaAcervo
      titulo="Divulgações"
      descricao="Peças intercaladas entre as fotos na galeria do salão. Aceita imagem e vídeo."
      rotaUpload="/api/divulgacoes/upload"
      itens={lista.data ?? []}
      carregando={lista.isLoading}
      proporcao="cover"
      aceita={`${IMAGENS},video/mp4,video/webm`}
      aoRecarregar={() => void utils.divulgacoes.list.invalidate()}
      aoExcluir={async (ids) => {
        // Divulgações não têm exclusão em lote no servidor: são poucas e
        // costumam ser removidas uma a uma.
        for (const id of ids) await excluir.mutateAsync({ id });
      }}
      excluindo={excluir.isPending}
      editor={(item, aoFechar) => {
        // O componente genérico não conhece campos de divulgação; a tela busca a
        // linha completa por id na lista que já tem em mãos.
        const d = lista.data?.find((x) => x.id === item.id);
        if (!d) return null;

        return (
          <EditorDivulgacao
            id={d.id}
            titulo={d.title}
            duracao={d.durationSeconds}
            status={d.status}
            ehVideo={d.mediaType === "video"}
            aoFechar={aoFechar}
          />
        );
      }}
    />
  );
}
